import { useEffect } from 'react';
import Navbar from 'src/components/NavBar';
import useGuideMe from 'src/hooks/useGuideMe';
import { guideMeSteps } from './ActionRequiredGuideMeSteps';

const ActionRequiredInvoicesNavBar = () => {
  const { guideMe, openGuideMe } = useGuideMe({
    steps: guideMeSteps,
    guideId: 'action-required-guide',
  });
  useEffect(() => {
    openGuideMe();
  }, [openGuideMe]);
  return (
    <>
      <Navbar title={'Action Required for Invoices/Credits'} />
      <nav className="h-12 shadow-md flex items-center justify-end px-4">{guideMe}</nav>
    </>
  );
};

export default ActionRequiredInvoicesNavBar;
